import { useDispatch } from "react-redux";
import { store } from 'Store';
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { http } from "Utils";
import { httpDownload } from "Utils/httpDownload";
import DatatableBase from "Components/Datatable/DatatableBase";
import { Datatable_Column } from "Components/Datatable/DatatableComponents/DatatableColumn";
import { TextButton } from "Components/Button";
import { ERROR_MESSAGES } from "Utils/constants";
import { setGlobalErrorStatus } from 'Components/StatusHandling'
import { Row, Col, Card, Stack } from "react-bootstrap";
import RenderSortIcon from "Components/Datatable/RenderSortIcon";
import { ICONS } from "Utils/icons";
import { TableIconTextButton } from "Components/Button";

const CDABatchDetail = () => {
  const loginState = store.getState().loginInfo;
  const location = useLocation();
  const navigate = useNavigate();
  const passedData = location.state;
  const batchId = passedData.id;
  const [isLoading, setIsLoading] = useState(true);
  const [batchInfo, setBatchInfo] = useState({});
  const dispatch = useDispatch();
 
  const [backRedirect, setBackRedirect] = useState(passedData.backRedirect);

  const batchFileInfoSearchFieldText = "Search by File Name";
  const batchFileInfoHeader = "Batch File Information";
  const batchFileInfoSortId = 'name';
  const batchFileInfoSortOrder = 'desc';

  const getBatchDetailInfo = async () => {

    const url = "/api/cda/batchDetail";
    const body = { "batchId": batchId };

    const res = await http.post(url, body, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    }).then((res) => {
      //console.log("getBatchDetailInfo", res);
      if (res.status !== 1) {
        setGlobalErrorStatus({
          dispatch: dispatch,
          popupData: {
            visible: true,
            title: ERROR_MESSAGES.DATA_ERROR.title,
            msg: res.globalErrorMessageList[0],
            showContactHelp: true
          },
          redirect: {
            redirect: false,
            redirectFirst: false,
            path: "",
            data: {}
          }
        });
      }
      else {
        var d = res.data;
        setBatchInfo(res.data);

      }
      setIsLoading(false);

    }).catch((error) => {
      //console.log("error getBatchDetailInfo()", error);
      setIsLoading(false);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });
  }

  useEffect(() => {
    getBatchDetailInfo();
    window.scrollTo(0, 0);
  }, [])

  // render batch info
  const BatchInfoField = ({ name, value }) => {
    return (
      <div className="info-field-row" key={name + value}>
        <Col sm={4} lg={4}>
          <p className="name w-auto">{name}</p>
        </Col>
        <Col sm={7} lg={7}>
          <p className="value w-auto">{value}</p>
        </Col>
      </div>
    )
  }


  const getSubmissionType = () => {

    let env = "";

    if (batchInfo.batchDetail?.testCase === "Y") {
      env = "Test";
    } else if (batchInfo.batchDetail?.testCase === "N") {
      env = "Production";
    }

    if (batchInfo.batchDetail?.srcCd && batchInfo.batchDetail?.srcCd !== "") {
      return env + "(" + batchInfo.batchDetail.srcCd + ")";
    } else {
      return env;
    }

  }

  const handleDateFormat = (time) => {

    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let min = date.getMinutes();

    return (
      <div>
        {month < 10 ? "0" + month : month}/
        {day < 10 ? "0" + day : day}/
        {year + " "}
        {hour < 10 ? "0" + hour : hour}:
        {min < 10 ? "0" + min : min}
      </div>
    )
  }

  const convertBooleanToText = (value) => {
    if (value == 1) {
      return "Yes";
    }
    else {
      return "No";
    }
  }

  // api to get batch file info
  const getBatchFileInfo = async (filter) => {
    var call = {
      paginationRequest: filter,
      batchId: batchId
    }

    var url = '/api/cda/batchFileInfo';

    return http.post(url, call, {
      headers: {
        "Authorization": "Bearer " + loginState.token
      }
    });
  }

  /*
  Column structure:
    {
      name: <div tabIndex={0} className="datatable-col-name">Batch ID  <div className="dataTableSortIcon"><RenderSortIcon sortDirection={deletedPSETestBatchSortColumn.sortField == "pseBatchId" ? deletedPSETestBatchSortColumn.sortDirection : ""} /></div></div>,
      //name: 'Batch ID',row.pseBatchId,
      selector: row => <a href="">{row.pseBatchId}</a>,
      sortable: true,
      sortField: 'pseBatchId',
      //width: "12%",
    }
  */

  const getListCols = (selectedList, sortingInfo) => {
    //console.log("getListCols", sortingInfo);
    const listColumns = [];

    listColumns.push(Datatable_Column({ name: "Common Format", columnName: "timePeriod.timePrdCd", selectedRows: selectedList, sortable: true, sortFieldNum: 0, sortingInfo: sortingInfo }))
    //listColumns.push(Datatable_Column({ name: "File Name", columnName: "name", selectedRows: selectedList, sortable: true, sortFieldNum: 1, isButton: true, buttonData: { title: "", action: handleFileDownload, text: "" }, sortingInfo: sortingInfo }))
    // logic to decide if a file can be downloaded row.hasFileData == 1 && row.status.id != 13 && row.status.id != 14
    listColumns.push({
      id: "name",
      name:
        <div className="datatable-col-name">
          File Name
          <div className="dataTableSortIcon">
            <RenderSortIcon sortDirection={sortingInfo.sortingColumn == "name" ? sortingInfo.sortingOrder : ""} />
          </div>
        </div>,
      selector: row => {
        if (row.hasFileData == 1 && row.status.id != 13 && row.status.id != 14) {
          return (
            <div className="non-link-table-cell-data is-button is-break-all">
              <TableIconTextButton onClick={() => handleFileDownload(row.id, row.name)} className="table-action" variant="table"
                title={row.name} icon={ICONS.download}
                content={row.name}
              >
              </TableIconTextButton>
            </div>
          )
        }
        return (
          <span>{row.name}</span>
        )
      },
      sortable: true,
      sortField: 1,
      sortColumnName: 'name',
    });
    listColumns.push(Datatable_Column({ name: "File Status", columnName: "status.description", selectedRows: selectedList, sortable: true, sortFieldNum: 2, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Is Same CF Resubmission", columnName: "isResubmission", selectedRows: selectedList, sortable: true, sortFieldNum: 3, formatFunction: convertBooleanToText, sortingInfo: sortingInfo }))
    listColumns.push(Datatable_Column({ name: "Is Cross CF Resubmission", columnName: "isCrossCFResubmission", selectedRows: selectedList, sortable: true, sortFieldNum: 4, formatFunction: convertBooleanToText, sortingInfo: sortingInfo }))

    return listColumns;
  }

  const handleFileDownload = async (fileId, fileName) => {

    const res = await submitDownload(fileId);
    //console.log("after handleFileDownload", res);

    if (res) {

      let url = window.URL.createObjectURL(res.data);
      let a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a); // append the element to the dom
      a.click();
      a.remove(); // afterwards, remove the element  
    }
  }

  const submitDownload = async (fileId) => {
    const call = {
      fileId: fileId
    }

    const url = '/api/cda/downloadXMLFile';

    return httpDownload.post(url, call, {
      responseType: "blob",
      headers: {
        "Authorization": "Bearer " + loginState.token,
      },
    }).catch((error) => {
      //console.log("error handleFileDownload()", error);
      setGlobalErrorStatus({
        dispatch: dispatch,
        popupData: {
          visible: true,
          title: ERROR_MESSAGES.DATA_ERROR.title,
          msg: ERROR_MESSAGES.DATA_ERROR.message,
          showContactHelp: true
        },
        redirect: {
          redirect: false,
          redirectFirst: false,
          path: "",
          data: {}
        },
        error: error
      });
    });;
  }

  // navigate back to CDA Submission
  const backToCDASubmission = (batchInfo) => {
    navigate("/data/cda",
      {
        state: {
          tabKey: batchInfo.batchDetail?.batchStatus === "Completed" ? "completed" : "inProgress",
          envKey: batchInfo.batchDetail?.testCase === "Y" ? "cdaTest" : "cdaProd"
        }
      }
    );
  }

  const handleBack = () => {
    if(backRedirect==null){
        backToCDASubmission(batchInfo)
    }
    else{
        navigate(
            backRedirect.path != null ? backRedirect.path : "/data/cda",
            { state: backRedirect.state }
        );
    }
    
  }

  return (
    <Row>{isLoading == false ?
      <Col xl={11} lg={11} md={11} sm={12}>
        <Card className="p-4">
          <Card.Body className="text-start">
            <h1 id="mainContent" className="header1 text-start mb-3 blue bold">
              View
              {batchInfo.batchDetail?.testCase === "Y" ? " Test " : ""}
              {batchInfo.batchDetail?.testCase === "N" ? " Production " : ""}
              Batch Details
            </h1>
            <h2 className="text-start mb-3 form-title">Batch Information</h2>
            <Col className="mb-5" >
              <div className="info-container">
                <BatchInfoField name={"Batch ID"} value={batchInfo.batchDetail?.id}></BatchInfoField>
                <BatchInfoField name={"CF Setting"} value={batchInfo.batchDetail?.cfSetting}></BatchInfoField>
                <BatchInfoField name={"Submission Type"} value={getSubmissionType()}></BatchInfoField>
                <BatchInfoField name={"User Name"} value={batchInfo.batchDetail?.firstName + " " + batchInfo.batchDetail?.lastName}></BatchInfoField>
                <BatchInfoField name={"PSO ID - Name"} value={batchInfo.batchDetail?.submitPsoId + " - " + batchInfo.batchDetail?.submitOrgName}></BatchInfoField>
                {/** display vendor info if it is vendor submission */}
                {batchInfo.vendorSubmission && batchInfo.vendorSubmission === true ?
                  <BatchInfoField name={"Vendor ID - Name"} value={batchInfo.batchDetail?.psoId + " - " + batchInfo.batchDetail?.organizationName}></BatchInfoField>
                  :
                  null
                }
                <BatchInfoField name={"Submission Date"} value={handleDateFormat(batchInfo.batchDetail?.submitDate)}></BatchInfoField>
                <BatchInfoField name={"Batch Status"} value={batchInfo.batchDetail?.batchStatus}></BatchInfoField>
                <BatchInfoField name={"No. Of Files"} value={batchInfo.batchDetail?.fileCount}></BatchInfoField>
                {batchInfo.batchDetail?.cfSetting && batchInfo.batchDetail?.cfSetting === 'Hospital' ?
                  <>
                    <BatchInfoField name={"Accepted Full"} value={batchInfo.batchDetail?.accepted + batchInfo.batchDetail?.fullDataSet}></BatchInfoField>
                    <BatchInfoField name={"Accepted Partial"} value={batchInfo.batchDetail?.partialDataSet}></BatchInfoField>
                    <BatchInfoField name={"Accepted Minimum"} value={batchInfo.batchDetail?.minimumDataSet}></BatchInfoField>
                  </>
                  :
                  <BatchInfoField name={"Accepted"} value={batchInfo.batchDetail?.totalAccepted}></BatchInfoField>

                }
                <BatchInfoField name={"Rejected"} value={batchInfo.batchDetail?.rejected}></BatchInfoField>
                <BatchInfoField name={"Same CF Resubmits"} value={batchInfo.batchDetail?.sameCFResubmits}></BatchInfoField>
                <BatchInfoField name={"Cross CF Resubmits"} value={batchInfo.batchDetail?.crossCFResubmits} ></BatchInfoField>
              </div>
            </Col>

            <DatatableBase
              tableClassName="cdaBatchFileInfoTable"
              getData={getBatchFileInfo}
              getListCols={getListCols}
              //setSelectedCount={setSelectedCount} 
              hasSelectableRows={false}
              searchFieldText={batchFileInfoSearchFieldText}
              datatableHeader={batchFileInfoHeader}
              datatableDescription={null}
              sortingColumn={batchFileInfoSortId}
              sortingOrder={batchFileInfoSortOrder}
            >
            </DatatableBase>
            
            <Stack className="mt-3" direction="horizontal" gap={3}>
                {/* Back Button */}
                <TextButton
                    variant="outline"
                    onClick={handleBack}
                    content={"Back"}
                    className="ms-auto"
                >
                </TextButton>
            </Stack>

          </Card.Body>
        </Card >
      </Col> : null
    }
    </Row>
  )
}

export default CDABatchDetail;